import CryptoJS from "crypto-js";

export const decrypt = function(code){
    const key = process.env.VUE_APP_PWS;
    console.log(key);
    const encryptStr = CryptoJS.enc.Base64.parse(code);
    let encryptData = encryptStr.toString(CryptoJS.enc.Utf8);
    encryptData = JSON.parse(encryptData);
    let iv = CryptoJS.enc.Base64.parse(encryptData.iv);
    var decrypted = CryptoJS.AES.decrypt(encryptData.value,  CryptoJS.enc.Utf8.parse(key), {
        iv : iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypted); 
}

export const exstract = function(str){
    const seperator = process.env.VUE_APP_SEPERATOR;
    return str.split(seperator);
}
